"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseAbilityOnTargetActionHandler = exports.UseAbilityOnTargetActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
const Target_1 = require("../../Target");
const AbilityArgs_1 = require("../../abilities/AbilityArgs");
class UseAbilityOnTargetActionArgs {
    constructor(ability, target, requireSlotted = true, ignoreControlMechanics = false) {
        this.ability = ability;
        this.target = target;
        this.requireSlotted = requireSlotted;
        this.ignoreControlMechanics = ignoreControlMechanics;
        this.__type = ActionType_1.ActionType.UseAbilityOnTarget;
        this.__typeName = "UseAbilityOnTarget";
    }
}
exports.UseAbilityOnTargetActionArgs = UseAbilityOnTargetActionArgs;
let UseAbilityOnTargetActionHandler = class UseAbilityOnTargetActionHandler {
    activate(sequence, container, action) {
        if (!(action.args.ignoreControlMechanics || container.canUseAction(action.actorId))) {
            return;
        }
        const targetIds = container.selectLivingTargets(action.actorId, action.args.target);
        if (targetIds.length === 0) {
            return;
        }
        const args = AbilityArgs_1.AbilityArgs.FromTypeName(action.args.ability, Target_1.Target.Any(targetIds));
        container.useAbility(sequence, action.actorId, args, action.args.requireSlotted);
    }
};
UseAbilityOnTargetActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.UseAbilityOnTarget)
], UseAbilityOnTargetActionHandler);
exports.UseAbilityOnTargetActionHandler = UseAbilityOnTargetActionHandler;
